var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8024 4.35296C11.7657 4.24497 11.6982 4.15007 11.6083 4.07999C11.5183 4.00992 11.4097 3.96773 11.2961 3.95863L7.97047 3.69438L6.53139 0.508794C6.48556 0.406192 6.41102 0.319048 6.31675 0.257877C6.22249 0.196707 6.11254 0.164124 6.00016 0.164063C5.88779 0.164001 5.7778 0.196462 5.68347 0.25753C5.58914 0.318597 5.5145 0.405659 5.46856 0.50821L4.02947 3.69438L0.703891 3.95863C0.592157 3.96748 0.485338 4.00833 0.396215 4.0763C0.307092 4.14427 0.239437 4.23648 0.201346 4.34189C0.163254 4.44731 0.156338 4.56146 0.181426 4.6707C0.206513 4.77994 0.262542 4.87964 0.342808 4.95788L2.80039 7.35363L1.93122 11.1173C1.90483 11.2312 1.91329 11.3504 1.9555 11.4595C1.99771 11.5686 2.07173 11.6624 2.16794 11.7289C2.26416 11.7954 2.37813 11.8314 2.49507 11.8323C2.612 11.8331 2.72651 11.7989 2.82372 11.7339L5.99997 9.61638L9.17622 11.7339C9.27559 11.7998 9.39277 11.8338 9.51201 11.8312C9.63125 11.8286 9.74683 11.7895 9.8432 11.7192C9.93958 11.649 10.0121 11.5509 10.0511 11.4382C10.0901 11.3254 10.0936 11.2035 10.0611 11.0887L8.99422 7.35538L11.6402 4.97421C11.8135 4.81788 11.8771 4.57404 11.8024 4.35296Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.acbc0deebbf8ac796d50c5ccc6186edd.svg";
export { ForwardRef as ReactComponent };